import type { TypographyVariants } from '../../../Typography/types';
import type { ToggleButtonGroupSizes } from '../../types';

export const buttonGroupIconSizeMap: Record<ToggleButtonGroupSizes, number> = {
  xs: 14,
  sm: 16,
  md: 18,
  lg: 20,
};

export const buttonGroupTextVariantMap: Record<ToggleButtonGroupSizes, TypographyVariants> = {
  xs: 'text-xxs',
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-sm',
};
